export default __webpack_public_path__ + "static/castleft-0203b95e67a4aebe843371d8097cb849.png";